var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSizeDefault = function SvgSizeDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    fillOpacity: 0.5,
    d: "M11 15h78v19H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    d: "M16 20h68v9H16zM16 45h68v9H16zM16 70h68v9H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    fillOpacity: 0.5,
    d: "M11 40h78v19H11zM11 65h78v19H11z"
  })));
};
export { SvgSizeDefault as ReactComponent };
export default __webpack_public_path__ + "img/size-default.f61801481be71cd68c94c5872af99c42.svg";